const teams = {
    leafs: {
        id: 10,
        name: "Toronto Maple Leafs"
    },
    habs: {
        id: 8,
        name: "Montréal Canadiens"
    }
};

export default teams.leafs;
